import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { string, bool, oneOf } from 'prop-types'
import HeaderWithImage from '@groovehq/internal-design-system/lib/components/HeaderWithImage/HeaderWithImage'
import { doDeleteFolders } from 'ducks/folders/operations/folders'
import EntityDeleteDrawer from '../EntityDelete'
import FolderDeleteContent from './Content'

const FolderDeleteDrawer = props => {
  const {
    title,
    deleteBtnText,
    open,
    drawerResourceId,
    drawerDeleteMode,
    onClose,
    onRemove,
  } = props

  const dispatch = useDispatch()

  const ids = useMemo(
    () => {
      return drawerResourceId.split(',')
    },
    [drawerResourceId]
  )
  const handleOnRemove = useCallback(
    () => {
      dispatch(doDeleteFolders(ids))
      if (onRemove) onRemove()
    },
    [dispatch, ids, onRemove]
  )

  const handleOnClose = useCallback(
    () => {
      const closeOptions = {}
      onClose(closeOptions)
    },
    [onClose]
  )

  return (
    <EntityDeleteDrawer
      {...props}
      onRemove={handleOnRemove}
      onClose={handleOnClose}
      onCancel={handleOnClose}
      title={title}
      deleteBtnText={deleteBtnText}
      deleteBtn
      tertiaryBtnText={'Cancel'}
      open={open}
      skipProceedQuestion
      hardDelete
    >
      <HeaderWithImage
        className="grui mb-12"
        img={null}
        imgWidth="120px"
        alt="Deletion"
        title="Confirm deletion"
        intro={null}
      />
      <FolderDeleteContent ids={ids} deleteMode={drawerDeleteMode} />
    </EntityDeleteDrawer>
  )
}

FolderDeleteDrawer.propTypes = {
  title: string,
  deleteBtnText: string,
  open: bool.isRequired,
  drawerDeleteMode: oneOf(['ids', 'query']),
  drawerResourceId: string,
}

FolderDeleteDrawer.defaultProps = {
  title: 'Delete Folder',
  deleteBtnText: 'Delete',
  drawerDeleteMode: 'ids',
  drawerResourceId: '',
  queryId: null,
}

export default FolderDeleteDrawer
